import React, { useState, useCallback } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Box,
  SelectChangeEvent,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

interface Option {
  label: string;
  value: string;
}

interface EnrollmentOptionProps {
  typeOptions: Option[];
  enrollmentOptions: Option[];
  onTypeChange: (selected: string) => void;
  onEnrollmentSelect: (enrollment: Option | null) => void;
}

function EnrollmentOptions({
  typeOptions,
  enrollmentOptions,
  onTypeChange,
  onEnrollmentSelect,
}: EnrollmentOptionProps) {
  const [selectedType, setSelectedType] = useState<string>('');
  const [enrollmentValue, setEnrollmentValue] = useState<Option | null>(null);
  const [inputValue, setInputValue] = useState<string>('');

  const handleTypeChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      const type = event.target.value;
      setSelectedType(type);
      setEnrollmentValue(null);
      setInputValue('');
      onTypeChange(type);
    },
    [onTypeChange]
  );

  const handleEnrollmentChange = useCallback(
    (_event: React.ChangeEvent<{}>, newValue: Option | null) => {
      setEnrollmentValue(newValue);
      onEnrollmentSelect(newValue);
      setEnrollmentValue(null);
      setInputValue('');
    },
    [onEnrollmentSelect]
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <FormControl fullWidth>
        <InputLabel id="select-label">Type</InputLabel>
        <Select
          labelId="select-label"
          variant="outlined"
          value={selectedType}
          onChange={handleTypeChange}
          label="Type"
        >
          {typeOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Autocomplete
        key={selectedType}
        options={enrollmentOptions.filter(
          option => !enrollmentValue || option.value !== enrollmentValue.value
        )}
        getOptionLabel={option => option.label}
        value={enrollmentValue}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={handleEnrollmentChange}
        renderInput={params => <TextField {...params} label="Enrollments" variant="outlined" />}
        disabled={!selectedType}
      />
    </Box>
  );
}

export default EnrollmentOptions;
